import typeCheck from 'common/util/typeCheck';
import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_APARTMENT_LOCATOR_CHECK_AVAILABILITY_BUTTON_CLICK,
} from 'client/analytics/eventList';
import { SR_API_ACTION_LISTING_CHECK_AVAILABILITY_BUTTON_CLICK } from 'api/actionTypes';

export default async function checkAvailabilityButtonClick(
  { state, history, apiClient },
  { listingId },
) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('history::NonEmptyObject', history);

  const userPhoneVerified = state.get(['currentUser', 'phoneVerified']);
  if (!userPhoneVerified) {
    history.push(`/listing/${listingId}/verify-phone?source=checkAvailability`);
  }
  else if (!state.exists(['checkAvailabilityByListingId', listingId])) {
    analytics.track(ANALYTICS_EVENT_APARTMENT_LOCATOR_CHECK_AVAILABILITY_BUTTON_CLICK);

    await apiClient.postWithState({
      action: SR_API_ACTION_LISTING_CHECK_AVAILABILITY_BUTTON_CLICK,
      state: state,
      payload: {
        listingId,
      },
      onSuccess() {
        state.set(['checkAvailabilityByListingId', listingId], true);
      },
    });

    history.push(`/listing/${listingId}/apartment-locator`);
  }
}
